/** @jsx jsx */
import {jsx} from 'theme-ui'
import selectedIcon from 'images/selected.svg'
import {useTranslation} from 'react-i18next'
import {AllDonationType, DonationPurpose, DonationType} from './shared'

interface IDonationTypeBlock {
  donationPurpose: DonationPurpose
  donationType: AllDonationType
  setDonationType: (donationType: AllDonationType) => void
  donationTypes: string[]
}

const customDonationTypeNames: {[key: string]: {[key: string]: string}} = {
  'Atlas Relief': {
    'One Time': 'Atlas Amount',
  },
}

const DonationTypeBlock: React.FC<IDonationTypeBlock> = ({
  donationPurpose,
  donationType,
  donationTypes,
  setDonationType,
}) => {
  const {t} = useTranslation()

  return (
    <div
      sx={{
        display: 'flex',
      }}
    >
      {donationTypes.length > 1 &&
        donationTypes.map((name, index, arr) => {
          const isSelected = donationType === name
          const handleClick = () => {
            if (!isSelected) setDonationType(name as DonationType)
          }
          return (
            <button
              key={name}
              onClick={handleClick}
              type="button"
              sx={{
                flex: donationTypes.length > 2 ? 'auto' : 1,
                fontSize: donationTypes.length > 2 ? 13 : 14,
                cursor: 'pointer',
                height: [44, , 38],
                borderTopRightRadius: index === arr.length - 1 ? 4 : 0,
                borderTopLeftRadius: index === 0 ? 4 : 0,
                borderColor: 'primary',
                borderLeftColor: index === 0 ? 'primary' : 'transparent',
                borderWidth: 1,
                backgroundColor: isSelected ? 'primary' : 'transparent',
                color: isSelected ? '#fff' : 'primary',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img
                alt=""
                src={selectedIcon}
                sx={{
                  display: isSelected ? 'inline' : 'none',
                  marginRight: 6,
                }}
              />
              {t(customDonationTypeNames?.[donationPurpose]?.[name] || name)}
            </button>
          )
        })}
    </div>
  )
}

export default DonationTypeBlock
